"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "schedules.closedSlot";
  var componentName = "closedSlot";

  // Occurrences x conseillers : plafond de créations par validation.
  var MAX_CLOSED_SLOTS = 500;

  var bindings = {
    resolve: "<?",
    _id: "<?"
  };

  var templateUrl = "app/pages/schedules/closedSlot/closedSlot.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $window, $timeout, UsersService, DepasService, OperatorsService, FormlyService, CustomListsService, ModalService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$timeout = $timeout;
      this.UsersService = UsersService;
      this.DepasService = DepasService;
      this.ModalService = ModalService;
      this.CustomListsService = CustomListsService;
      this.FormlyService = FormlyService;
      this.OperatorsService = OperatorsService;
    }

    _createClass(Controller, [{
      key: "close",
      value: function close() {
        if (this.saving) return;
        console.log("$scope", this.$scope);
        if (this.$scope.$parent) {
          this.$scope.$parent.$dismiss();
        }
        Notiflix.Loading.remove();
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this = this;

          var closedSlotId, closedSlot, params;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.$scope.$on("modal.closing", function (event, reason, closing) {
                    if (_this.saving && !closing) event.preventDefault();
                  });
                  Notiflix.Loading.standard("Chargement...");

                  _context.next = 4;
                  return this.OperatorsService.getSelectArray();

                case 4:
                  this.operators = _context.sent;
                  closedSlotId = this.resolve.params._id;
                  closedSlot = void 0;

                  if (!closedSlotId) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 10;
                  return this.DepasService.findById({
                    _id: closedSlotId.replace("$", "")
                  });

                case 10:
                  closedSlot = _context.sent;

                case 11:

                  if (closedSlot && closedSlot.slot) {
                    this.model = {
                      operatorId: closedSlot.slot.operatorId,
                      startDate: moment(closedSlot.slot.start).format("YYYY-MM-DD"),
                      startTime: moment(closedSlot.slot.start).format("HH:mm"),
                      endDate: moment(closedSlot.slot.end).format("YYYY-MM-DD"),
                      endTime: moment(closedSlot.slot.end).format("HH:mm"),
                      note: closedSlot.note
                    };
                  } else {
                    // Le planning pré-remplit le conseiller et le jour cliqués.
                    params = this.resolve.params;

                    this.model = {
                      operatorId: params.operatorId || null,
                      startDate: params.date || null,
                      startTime: "7:00",
                      endDate: params.date || null,
                      endTime: "20:00",
                      rrule: null,
                      note: null
                    };
                  }

                  _context.next = 14;
                  return this.createFields();

                case 14:

                  this.$timeout(function () {}, 10);
                  Notiflix.Loading.remove();

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()

      // Récurrence active dès que le widget a produit une règle RRULE.

    }, {
      key: "createFields",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2 = this;

          var fields, boxes, operator, operatorName;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  fields = [this.FormlyService.date("startDate", "Date de début", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.time("startTime", "Heure de début", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }),
                  // Avec une récurrence, c'est la règle qui porte la fin de série.
                  this.FormlyService.date("endDate", "Date de fin", true, {
                    className: "col-xs-12 col-sm-6 col-md-6",
                    hideExpression: "!!(model.rrule && model.rrule.rrule)"
                  }), this.FormlyService.time("endTime", "Heure de fin", true, {
                    className: "col-xs-12 col-sm-6 col-md-6"
                  }), this.FormlyService.text("note", "Description", true, {
                    className: "col-xs-12 col-sm-12 col-md-12"
                  })];

                  // Référence et non copie : la liste des conseillers est ajoutée plus bas.

                  boxes = [{
                    mainTitle: "Informations",
                    fields: fields
                  }];


                  if (this.resolve.params._id) {
                    operator = this.operators.find(function (item) {
                      return item.value === _this2.model.operatorId;
                    });
                    operatorName = operator ? operator.name : "?.?";

                    this.displayTitle = "Modification d'une p\xE9riode ferm\xE9e pour " + operatorName;
                  } else {
                    this.displayTitle = "Création d'une période fermée";
                    fields.unshift(this.FormlyService.list("operatorId", "Conseiller/ère", [{ name: "Tous les conseillers/ères", value: "all" }].concat(_toConsumableArray(this.operators)), true, {
                      className: "col-xs-12 col-sm-12 col-md-12"
                    }));

                    // Une modification porte toujours sur une occurrence isolée.
                    boxes.push({
                      mainTitle: "Répétition (laisser sur « Jamais » pour une période continue)",
                      fields: [this.FormlyService.rrule("rrule", {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    });
                  }

                  this.rows = [{
                    columns: [{
                      class: "col-xs-12 col-sm-12 col-md-12",
                      boxes: boxes
                    }]
                  }];

                  this.$timeout(function () {}, 0);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function createFields() {
          return _ref2.apply(this, arguments);
        }

        return createFields;
      }()

      // Applique une heure "HH:mm" à une date.

    }, {
      key: "applyTime",
      value: function applyTime(date, time) {
        var parts = String(time).split(":");
        return moment(date).set({
          hour: Number(parts[0]),
          minute: Number(parts[1]),
          second: 0,
          millisecond: 0
        });
      }

      // Renvoie { periods, error } : une période continue sans récurrence, sinon
      // la tranche horaire reportée sur chaque occurrence.

    }, {
      key: "buildPeriods",
      value: function buildPeriods() {
        var _this3 = this;

        var recurrence = this.recurrence;

        if (!recurrence) {
          var start = this.applyTime(this.model.startDate, this.model.startTime);
          var end = this.applyTime(this.model.endDate, this.model.endTime);

          if (end.diff(start) <= 0) {
            return {
              error: "Le début de la période doit être strictement supérieur à la fin de la période !"
            };
          }

          return { periods: [{ start: start.toDate(), end: end.toDate() }] };
        }

        if (!recurrence.until) {
          return {
            error: "La date de fin de la répétition est obligatoire !"
          };
        }

        var firstStart = this.applyTime(this.model.startDate, this.model.startTime);
        var firstEnd = this.applyTime(this.model.startDate, this.model.endTime);

        if (firstEnd.diff(firstStart) <= 0) {
          return {
            error: "Avec une répétition, l'heure de fin doit être strictement supérieure à l'heure de début !"
          };
        }

        var until = moment(recurrence.until).endOf("day");
        if (until.diff(firstStart) < 0) {
          return {
            error: "La date de fin de la répétition doit être postérieure à la date de début !"
          };
        }

        // UNTIL à minuit (cas « chaque jour ») amputerait le dernier jour, les
        // occurrences tombant à l'heure de début ; la borne vient de until.
        var rruleString = recurrence.rrule.replace(/;?UNTIL=[^;]*/i, "");

        // dtstart donne le point de départ et l'heure des occurrences.
        var rule = RRule.rrulestr(rruleString, {
          dtstart: firstStart.toDate()
        });

        var occurrences = rule.between(firstStart.toDate(), until.toDate(), true);

        if (!occurrences.length) {
          return {
            error: "La répétition choisie ne génère aucune date sur la période indiquée !"
          };
        }

        // Heures réappliquées par jour : insensible aux changements d'heure.
        var periods = occurrences.map(function (date) {
          return {
            start: _this3.applyTime(date, _this3.model.startTime).toDate(),
            end: _this3.applyTime(date, _this3.model.endTime).toDate()
          };
        });

        return { periods: periods };
      }
    }, {
      key: "save",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!this.saving) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  this.saving = true;
                  _context3.prev = 3;
                  _context3.next = 6;
                  return this.saveChanges();

                case 6:
                  _context3.prev = 6;

                  this.saving = false;
                  this.$timeout(function () {}, 0);
                  return _context3.finish(6);

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[3,, 6, 10]]);
        }));

        function save() {
          return _ref3.apply(this, arguments);
        }

        return save;
      }()
    }, {
      key: "saveChanges",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var save, periods, built, operators, total, first, last, confirmed, created, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, operatorId, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, period, depaParams, response, _response;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  save = true;


                  if (!this.model.operatorId) {
                    Notiflix.Notify.failure("Le nom du conseiller ou de la conseillère est obligatoire !");
                    save = false;
                  }
                  if (!this.model.startDate) {
                    Notiflix.Notify.failure("La date de début est obligatoire !");
                    save = false;
                  }
                  if (!this.model.startTime) {
                    Notiflix.Notify.failure("L'heure de début est obligatoire !");
                    save = false;
                  }
                  if (!this.recurrence && !this.model.endDate) {
                    Notiflix.Notify.failure("La date de fin est obligatoire !");
                    save = false;
                  }
                  if (!this.model.endTime) {
                    Notiflix.Notify.failure("L'heure de fin est obligatoire !");
                    save = false;
                  }
                  if (!this.model.note) {
                    Notiflix.Notify.failure("La description est obligatoire !");
                    save = false;
                  }

                  periods = [];

                  if (save === true) {
                    built = this.buildPeriods();

                    if (built.error) {
                      Notiflix.Notify.failure(built.error);
                      save = false;
                    } else {
                      periods = built.periods;
                    }
                  }

                  if (!(save !== true)) {
                    _context4.next = 11;
                    break;
                  }

                  return _context4.abrupt("return");

                case 11:
                  operators = [];

                  if (this.model.operatorId !== "all") {
                    operators = [this.model.operatorId];
                  } else {
                    operators = this.operators.map(function (item) {
                      return item.value;
                    });
                  }

                  total = periods.length * operators.length;

                  if (!(total > MAX_CLOSED_SLOTS)) {
                    _context4.next = 18;
                    break;
                  }

                  _context4.next = 17;
                  return swal("", "Cette r\xE9p\xE9tition g\xE9n\xE9rerait " + total + " p\xE9riodes ferm\xE9es (maximum " + MAX_CLOSED_SLOTS + "). R\xE9duisez la p\xE9riode ou le nombre de conseillers/\xE8res.", "error");

                case 17:
                  return _context4.abrupt("return");

                case 18:
                  if (!(periods.length > 1)) {
                    _context4.next = 26;
                    break;
                  }

                  first = moment(periods[0].start).format("DD/MM/YYYY");
                  last = moment(periods[periods.length - 1].start).format("DD/MM/YYYY");
                  _context4.next = 23;
                  return swal({
                    title: "Confirmer la fermeture",
                    text: periods.length + " journ\xE9e(s) seront ferm\xE9es de " + this.model.startTime + " \xE0 " + this.model.endTime + ", " + ("du " + first + " au " + last + ", pour " + operators.length + " conseiller(s)/\xE8re(s), ") + ("soit " + total + " p\xE9riode(s) ferm\xE9e(s)."),
                    icon: "info",
                    buttons: ["Annuler", "Valider"]
                  });

                case 23:
                  confirmed = _context4.sent;

                  if (confirmed) {
                    _context4.next = 26;
                    break;
                  }

                  return _context4.abrupt("return");

                case 26:

                  Notiflix.Loading.standard("Enregistrement...");

                  created = 0;
                  _context4.prev = 28;
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context4.prev = 32;
                  _iterator = operators[Symbol.iterator]();

                case 34:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context4.next = 80;
                    break;
                  }

                  operatorId = _step.value;
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context4.prev = 39;
                  _iterator2 = periods[Symbol.iterator]();

                case 41:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context4.next = 63;
                    break;
                  }

                  period = _step2.value;
                  depaParams = {
                    customerId: this.$rootScope.$selectedCustomerId,
                    status: "Fermé",
                    slot: {
                      operatorId: operatorId,
                      start: period.start,
                      end: period.end
                    },
                    note: this.model.note
                  };

                  if (!(this.resolve.params._id && this.model.operatorId !== "all")) {
                    _context4.next = 53;
                    break;
                  }

                  depaParams.informOperator = this.model.informOperator;
                  _context4.next = 48;
                  return this.DepasService.updateAttributesById(this.resolve.params._id.replace("$", ""), depaParams);

                case 48:
                  response = _context4.sent;

                  if (!(!response || !response._id)) {
                    _context4.next = 51;
                    break;
                  }

                  throw new Error("Invalid update response");

                case 51:
                  _context4.next = 58;
                  break;

                case 53:
                  _context4.next = 55;
                  return this.DepasService.customPost("createOneClosedSlot", depaParams);

                case 55:
                  _response = _context4.sent;

                  if (!(!_response || !_response.length || !_response[0] || !_response[0]._id)) {
                    _context4.next = 58;
                    break;
                  }

                  throw new Error("Invalid creation response");

                case 58:
                  created++;
                  if (total > 1) Notiflix.Loading.change("Cr\xE9ation " + created + " / " + total + "...");

                case 60:
                  _iteratorNormalCompletion2 = true;
                  _context4.next = 41;
                  break;

                case 63:
                  _context4.next = 69;
                  break;

                case 65:
                  _context4.prev = 65;
                  _context4.t0 = _context4["catch"](39);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context4.t0;

                case 69:
                  _context4.prev = 69;
                  _context4.prev = 70;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 72:
                  _context4.prev = 72;

                  if (!_didIteratorError2) {
                    _context4.next = 75;
                    break;
                  }

                  throw _iteratorError2;

                case 75:
                  return _context4.finish(72);

                case 76:
                  return _context4.finish(69);

                case 77:
                  _iteratorNormalCompletion = true;
                  _context4.next = 34;
                  break;

                case 80:
                  _context4.next = 86;
                  break;

                case 82:
                  _context4.prev = 82;
                  _context4.t1 = _context4["catch"](32);
                  _didIteratorError = true;
                  _iteratorError = _context4.t1;

                case 86:
                  _context4.prev = 86;
                  _context4.prev = 87;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 89:
                  _context4.prev = 89;

                  if (!_didIteratorError) {
                    _context4.next = 92;
                    break;
                  }

                  throw _iteratorError;

                case 92:
                  return _context4.finish(89);

                case 93:
                  return _context4.finish(86);

                case 94:
                  _context4.next = 107;
                  break;

                case 96:
                  _context4.prev = 96;
                  _context4.t2 = _context4["catch"](28);

                  console.error(_context4.t2);
                  Notiflix.Loading.remove();
                  _context4.prev = 100;
                  _context4.next = 103;
                  return swal("Enregistrement interrompu", created + " p\xE9riode(s) sur " + total + " ont \xE9t\xE9 confirm\xE9es. " + "La dernière opération peut avoir été enregistrée sans confirmation. " + "Vérifiez les périodes dans le planning avant de réessayer.", "error");

                case 103:
                  _context4.prev = 103;

                  // Ferme et recharge le planning, même si la réponse du serveur a été perdue.
                  // Le même formulaire ne doit pas rejouer les créations déjà enregistrées.
                  if (this.$scope.$parent) this.$scope.$parent.$close();
                  return _context4.finish(103);

                case 106:
                  return _context4.abrupt("return");

                case 107:
                  _context4.prev = 107;

                  Notiflix.Loading.remove();
                  return _context4.finish(107);

                case 110:

                  if (total > 1) {
                    Notiflix.Notify.success(total + " p\xE9riode(s) ferm\xE9e(s) cr\xE9\xE9e(s)");
                  }
                  if (this.$scope.$parent) {
                    this.$scope.$parent.$close();
                  }

                case 112:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[28, 96, 107, 110], [32, 82, 86, 94], [39, 65, 69, 77], [70,, 72, 76], [87,, 89, 93], [100,, 103, 106]]);
        }));

        function saveChanges() {
          return _ref4.apply(this, arguments);
        }

        return saveChanges;
      }()
    }, {
      key: "recurrence",
      get: function get() {
        return this.model && this.model.rrule && this.model.rrule.rrule ? this.model.rrule : null;
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();